// Functions relating to a cardholder's accounts

export const getCurrentAccount = cardholder =>
  cardholder.accounts.find(
    account =>
      account.processor_reference === cardholder.primary_processor_reference
  );
